import path from 'path';

import { reportFlowLoadingError } from 'src/dataLayer/remoteData/rollbar/index.ts';
import { FlowLoadingError } from './flowLoadingError';
import invalidLocaleRedirect from './invalidLocaleRedirect';
// TODO: get access to my-config in development
import {
  ASSET_URL,
  DEFAULT_FLOW_ID
} from 'src/dataLayer/env';

export const requestFlow = async (flowId = DEFAULT_FLOW_ID, setFlowConfig) => {
  const assetUrl = new URL(ASSET_URL);
  const flowUrl = new URL(path.join(assetUrl.pathname, `/assets/flows/${flowId}.json`), assetUrl.origin);

  return fetch(
    flowUrl.href, { headers: { Accept: 'application/json' } }
  )
    .then((response) => {
      if (!response.ok) { throw new Error('Could not load flow'); }
      return response.json();
    })
    .then((flowConfig) => {
      invalidLocaleRedirect(flowConfig.locales);
      setFlowConfig(flowConfig);
    })
    .catch((error) => {
      reportFlowLoadingError(flowId, error);
      if (flowId === DEFAULT_FLOW_ID) {
        // to be caught via ErrorBoundary
        throw new FlowLoadingError('failed to load flow', flowId);
      } else {
        // does only work, when the URL is complete - including node/{nodeIndex}
        // safety mechanism needed to ensure, all URLs will work
        const ppfUrl = new URL(window.location.href);
        const pathRemainder = ppfUrl.pathname.split('/').slice(0, -3);
        ppfUrl.pathname = [...pathRemainder, DEFAULT_FLOW_ID, 'node', '0'].join('/');
        return window.location.replace(ppfUrl.href);
      }
    });
};
